import styled from 'styled-components'
import { Box, ButtonStyled, SpanStyled } from './Elements';
import { useTranslation } from 'react-i18next'
import { Spinner } from "react-bootstrap";
import { ArrowDown } from './AllImages';
import { useRef } from "react";
export const sliceProps = (props, sub) => {
    const { children, ...otherProps } = props;
    sub.forEach(prop => delete otherProps[prop]);
    return otherProps;
}
export const ButtonWithIcon = (props) => {
    const unwantedProps = ['icon', 'label', 'className'];
    return (
        <ButtonWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                {props.icon && (
                    <props.icon width='18px' />
                )}
                <SpanStyled color='var(--white)' size='15px'>{props.label ? props.label : ''}</SpanStyled>
            </button>
        </ButtonWrapper>
    )
}
export const ContactButton = (props) => {
    const unwantedProps = ['icon', 'label', 'className'];
    return (
        <ContactWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                {props.icon && (
                    <props.icon width='18px' />
                )}
                <SpanStyled color='var(--secondaryColor)' size='16px'>{props.label ? props.label : ''}</SpanStyled>
            </button>
        </ContactWrapper>
    )
}
export const InputWithIcon = (props) => {
    const unwantedProps = ['icon', "label"];
    return (
        <InputStyledWrap className='position-relative' >
            <InputStyled {...sliceProps(props, unwantedProps)} className={`w-100 ${!props.icon ? 'no-icon' : ''}`} autoComplete='false' />
            {props.icon && (
                <props.icon width='18px' className='position-absolute' />
            )}
        </InputStyledWrap>
    )
}
export const InputStyledWrap = styled.div`
    svg {
    left: 13px;
    top: 12px;
    height: 20px;
    }
`
export const InputStyled = styled.input`
    border: none;
    height: 48px;
    color: var(--darkGrey) !important;
    border-radius: 6px;
    background: var(--white);
    border: 1px solid var(--border);
    font-size: 14px;
    font-family: var(--regular);
    body.rtl &{
        font-family: var(--arRegular);
    }
    &:not(.no-icon) {
        padding-left: 50px;
    }
    &.no-icon {
        padding-left: 18px;
    }
    padding-right: 18px;
    outline: none;
    &,&::placeholder {
        font-size: 14px;
        color: #a9a9a9 !important;
    }
`
export const ContactWrapper = styled.div`
  button {
    display: flex;
    align-items: center;
    background:${props => props.bg ? props.bg : "var(--white)"};
    color: ${props => props.color ? props.color : "var(--secondaryColor)"};
    padding: ${props => props.padding ? props.padding : "12px 20px"};
    border: ${props => props.border ? props.border : "none"};
    outline: ${props => props.border ? props.border : "none"};
    border-radius: ${props => props.radius ? props.radius : "8px"};
    box-shadow: ${props => props.shadow ? props.shadow : ""};
    line-height: 20px;
    gap: 8px;
    margin:0 0px;
    transition: all 0.5s ease;
    svg{
        [stroke]{
            stroke: ${props => props.stroke ? props.stroke : "var(--white)"} ;
        }
        [fill]{
            fill: ${props => props.fill ? props.fill : "var(--white)"};
        }
    }
    &:hover{
        background:var(--secondaryColor);
        outline:1px solid var(--white);
        color:var(--white);
        svg{
            [stroke]{
                stroke: var(--white) ;
            }
            [fill]{
                fill: var(--white);
            }
        }
        span{
            color:var(--white);
        }
    }
  }
`
export const NextBackButton = (props) => {
    const unwantedProps = ['backIcon', 'nextIcon', 'label', 'className', 'isLoading'];
    return (
        <NextBackWrapper 
            {...sliceProps(props, unwantedProps)} 
            className={`d-flex align-items-center ${props.className || ''}`}
            disabled={props.disabled}
            >
            <button 
                {...sliceProps(props, unwantedProps)} 
                className={`${props.backIcon && 'backBtn'} ${!props.icon ? 'Btn-icon' : ''}`} 
                autoComplete='false'
                disabled={props.disabled || props.isLoading}
                >
                {props.isLoading ? (
                    <Spinner className="custom-spinner" />
                ) : (
                    <>
                        {props.backIcon && (
                            <>
                                <props.backIcon width='20px' />
                                <SpanStyled color='var(--darkGrey)' size='14px'>{props.label ? props.label : ''}</SpanStyled>
                            </>
                        )}
                        {props.nextIcon && (
                            <>
                                <SpanStyled color='var(--white)' size='14px'>{props.label ? props.label : ''}</SpanStyled>
                                <props.nextIcon width='20px' />
                            </>
                        )}
                    </>
                )}
            </button>
        </NextBackWrapper>
    )
}
export const NextBackWrapper = styled.div`
    button {
        display: flex;
        align-items: center;
        background:${props => props.bg ? props.bg : "var(--secondaryColor)"};
        color: ${props => props.color ? props.color : "var(--secondaryColor)"};
        padding: ${props => props.padding ? props.padding : "12px 20px"};
        border: ${props => props.border ? props.border : "1px solid var(--secondaryColor)"};
        outline: ${props => props.outline ? props.outline : "none"};
        border-radius: ${props => props.radius ? props.radius : "8px"};
        box-shadow: ${props => props.shadow ? props.shadow : ""};
        text-transform: uppercase;
        line-height: 20px;
        gap: 8px;
        margin:0 0px;
        transition: all 0.5s ease;
        min-width: 120px;
        justify-content: center;
        .custom-spinner {
            color: ${(props) => (props.color ? props.color : "var(--white)")};
        }
        &.backBtn{
            border:1px solid var(--border);
        }
        span{
            font-family: var(--bold);
            font-size: 16px;
            body.rtl &{
                font-family: var(--arBold);
            }
        }
        svg{
            [stroke]{
            }
            [fill]{
            }
        }
        &:hover{
            background:transparent;
            border:1px solid var(--secondaryColor);
            color:var(--themeColor);
            svg{
                [stroke]{
                    stroke: ${props => props.stroke ? props.stroke : "var(--secondaryColor)"} ;
                }
                [fill]{
                    fill: ${props => props.fill ? props.fill : "var(--secondaryColor)"};
                }
            }
            span{
                color:var(--secondaryColor);
            }
        }
        &:disabled span{
            color: var(--lightGreyText);
        }
        &:disabled:hover{
            border:1px solid var(--border) !important;
            background: var(--greyBg);
            cursor: default;
            span{
                color: var(--lightGreyText);
            }
            svg{
                [stroke]{
                    stroke: ${props => props.stroke ? props.stroke : "#cdcdcd"} ;
                }
                [fill]{
                    fill: ${props => props.fill ? props.fill : "#cdcdcd"};
                }
            }
        } 
    }
`
export const ButtonWrapper = styled.div`
  button {
    display: flex;
    align-items: center;
    background-color:${props => props.bg ? props.bg : "transparent"};
    color: ${props => props.color ? props.color : "var(--themeColor)"};
    padding: ${props => props.padding ? props.padding : "7px 16px"};
    border: ${props => props.border ? props.border : "1px solid var(--themeColor)"};
    border-radius: ${props => props.radius ? props.radius : "6px"};
    background: transparent;
    gap: 8px;
    transition: all 0.5s ease;
    &:hover{
        background-color: var(--themeColor);
        border: 1px solid var(--themeColor);
        color: var(--white);
        svg{
            [stroke]{
                stroke: var(--white);
            }
            [fill]{
                fill: var(--white);
            }
        }
    }
    @media (max-width: 550px) {
        padding-left: 8px;
        padding-right: 8px;
        gap: 5px;
    }
}
`
export const SelectionDropdown = (props) => {
    const unwantedProps = ["options", "register", "validationRules"];
    const { register, validationRules, name } = props;
    const dropdownRef = useRef(null);
    return (
        <DropdownStyled
            {...sliceProps(props, unwantedProps)}
            ref={dropdownRef}
            arrow={ArrowDown}
            {...(register && register(name, validationRules))}
        >
            <option value="" className="label">
                {props.placeholder && props.placeholder}
            </option>
            {props.options &&
                props.options.length > 0 &&
                props.options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
        </DropdownStyled>
    );
};
const DropdownStyled = styled.select`
  height: 48px;
    color: var(--darkGrey) !important;
    border-radius: 6px;
    background: var(--white);
    border: 1px solid var(--border);
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  color: var(--text);
  font-family: var(--regular);
    body.rtl &{
        font-family: var(--arRegular);
    }
  cursor: pointer;
  .label {
    color: var(--darkGrey);
  }
  &::placeholder {
    color: var(--text2);
  }
  option[disabled] {
    color: var(--text2);
  }
`;